var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "doc-toolbar d-flex flex-row" },
    [
      _c(
        "b-dropdown",
        {
          attrs: {
            id: "trigger-download-selected-documents",
            size: "sm",
            variant: "primary",
            text: "Actions",
            disabled: _vm.disableActions,
          },
        },
        [
          _c(
            "b-dropdown-item",
            {
              on: {
                click: function ($event) {
                  return _vm.handleClick("download")
                },
              },
            },
            [
              _c("icon", { attrs: { name: "download" } }),
              _vm._v(" " + _vm._s(_vm.$t("documents.download")) + "\n    "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-dropdown-item",
            {
              on: {
                click: function ($event) {
                  return _vm.handleClick("edit")
                },
              },
            },
            [
              _c("icon", { attrs: { name: "pencil" } }),
              _vm._v(" " + _vm._s(_vm.$t("documents.rename")) + "\n    "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-dropdown-item",
            {
              on: {
                click: function ($event) {
                  return _vm.handleClick("move")
                },
              },
            },
            [
              _c("icon", { attrs: { name: "exchange" } }),
              _vm._v(
                " " + _vm._s(_vm.$t("documents.changeDocType")) + "\n    "
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.showExtract
            ? _c(
                "b-dropdown-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleClick("extract")
                    },
                  },
                },
                [
                  _c("icon", { attrs: { name: "magic" } }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("document-extraction.extractInformation")) +
                      "\n    "
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-dropdown-item",
            {
              attrs: { variant: "danger" },
              on: {
                click: function ($event) {
                  return _vm.handleClick("delete")
                },
              },
            },
            [
              _c("icon", { attrs: { name: "trash" } }),
              _vm._v(" " + _vm._s(_vm.$t("documents.delete")) + "\n    "),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }